module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "organizer"
    }
  }, [_c('h1', {
    staticClass: "title fourtitle"
  }, [_vm._v("共同主辦")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://sitcon.org/2017/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/sitcon.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("SITCON 學生計算機年會")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ocf.tw/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/OCFLogo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("開放文化基金會")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.cs.thu.edu.tw/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cs-logo.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("東海大學 資訊工程學系")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://itservice.thu.edu.tw/",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/itservice_logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("東海大學 電子計算機中心")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0453b526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organizer.vue
// module id = 80
// module chunks = 0